<template>
  <div>
    <div class="flagBar" align="right">
      <img
        v-for="language in languages"
        :key="language"
        class="mr-2 flagHower"
        :src="require(`@/assets/img/flags/${language}.png`)"
        @click="lang(language)"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      languages: ["de", "cs", "en", "ru", "es"],
    };
  },
  methods: {
    lang(lang) {
        this.$i18n.locale = lang
    },
  },
};
</script>
<style scoped>
.flagHower:hover {
  opacity: 0.6;
  cursor: pointer;
}
</style>